/** Auth events expose a generic rejection, not the underlying OTP HTTP status. */
export function canRetryFundingAuthentication(error) {
    return error.code === 'generic';
}
